jQuery(function($) {
 $("#vrm_search_form").submit(function(e){
     e.preventDefault();
   var vrm_number=$('#vrm_number').val();
   var rq='vrm='+vrm_number;
     location.href="https://"+window.location.hostname+"/pages/vrm-products?"+rq;
    });

  var app_url_d2p ='https://vrm.globalcarpart.com/index.php/';
  if (typeof getUrlVars()["vrm"]  !== "undefined"){

            var vrm=getUrlVars()["vrm"];
            $('#vrm_number').val(vrm);
            $.ajax({
              type: 'POST',
              url: app_url_d2p + "bgprocess/search_products",
              data: {
                vrm:vrm,
                 cid:$('.vrm-products').attr('data-cid'),
                email:$('.vrm-products').attr('data-email'),
                name:$('.vrm-products').attr('data-name'),
              },
              success: function (data) {
                
                if(data!=''){
                 
                 $('.vrm-products').html(data);
                }
              },
              });
                  
     }
  
});

function getUrlVars(){
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}